/**
 * Hamburger toggle for the navigation.
 */

const navigation = document.getElementById('site-navigation');
const toggleButton = document.getElementById('site-navigation-button');

const navigationActiveClassName = 'navigation--active';
const toggleButtonActiveClassName = 'hamburger--active';

const showNavigation = () => {
    navigation.classList.add(navigationActiveClassName);
    toggleButton.classList.add(toggleButtonActiveClassName);
    toggleButton.setAttribute('aria-expanded', 'true');
};

const hideNavigation = () => {
    navigation.classList.remove(navigationActiveClassName);
    toggleButton.classList.remove(toggleButtonActiveClassName);
    toggleButton.setAttribute('aria-expanded', 'false');
};

if (navigation && toggleButton) {
    toggleButton.addEventListener('click', e => {
        const isActive = toggleButton.getAttribute('aria-expanded') === 'true';
        if (isActive) {
            hideNavigation();
            closeAllFlyouts();
        } else {
            showNavigation();
        }
    });

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
            hideNavigation();
        }
    });
}

/**
 * Opening and closing for menu flyouts.
 */

/**
 * Close all flyouts on the page.
 */
const closeAllFlyouts = () =>
    document
        .querySelectorAll('[data-flyout-button]')
        .forEach(button => button.setAttribute('aria-expanded', 'false'));

/**
 * Open or close a flyout for the given menu item.
 * @param {HTMLButtonElement} button
 */
const toggleFlyout = button => {
    const isActive = button.getAttribute('aria-expanded') === 'true';

    // Allow only one open flyout in the desktop navigation
    const isMobileLayout = Boolean(toggleButton.offsetParent);
    if (!isMobileLayout) {
        closeAllFlyouts();
    }

    button.setAttribute('aria-expanded', isActive ? 'false' : 'true');
};

document.addEventListener('click', e => {
    if (!e.target.closest('[data-flyout-parent]')) {
        closeAllFlyouts();
        return;
    }

    const button = e.target.closest('[data-flyout-button]');
    if (!button) {
        return;
    }

    e.preventDefault();
    toggleFlyout(button);
});

document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') {
        return;
    }

    const parent = e.target.closest('[data-flyout-parent]');
    const button = parent?.querySelector('[data-flyout-button][aria-expanded="true"]');
    closeAllFlyouts();
    button?.focus();
});
